export enum DashboardIDs {
  Activities = 'bc90534e-3ae4-4e9b-a0e5-e7ede82cd524',
  ServiceRequests = 'f4c00233-3918-4032-9821-7bf593041bc8',
  Devices = 'b029bb70-e57d-4ecd-8fc5-2ae6f60803ba',
  Facilities = '6782b7e8-474b-436e-9f9a-a84ef3121a10',
  Financials = '415f7dbd-07be-47fb-af74-d6ca1340cb60',
  WarrantyAndContracts = 'ebcad525-df82-480a-be44-4e707adc21b5',
  Users = 'b913f873-0d81-4843-91b1-c6648553fbcf',
  Logs = 'd0ed01a2-35b4-4af8-bc0a-02692e6d1220',
}
